import React, { useMemo } from 'react';
import { gql, useFragment, useQuery } from '@apollo/client';
import { getPriceForSubscription } from 'app/utils/dish';
import formatPrice from 'app/utils/price';


const CART_SUBSCRIPTION = gql`
    query CART_SUBSCRIPTION(
    $period: String!
) {
    selectedPeriod @client @export(as: "period")

    cart(
        period: $period
    ) {
        period
        isSubscriptionActivated
        id
        type
        discount_conditions {
           isSubscriptionActivated
        }
    }
}`;

export const useDishPrice = ({ id }) => {
    /* DA */
    const { data } = useQuery(CART_SUBSCRIPTION, {
        fetchPolicy: 'cache-first',
    });

    const menuDish = useFragment({
        fragment: gql`
                fragment TOP_CARD_MENU_DISH on menuDish {
                    id,
                    price,
                }
            `,
        from: {
            __ref: `menuDish:${id}`,
        },
    });

    const isSubscription = useMemo(
        () => data?.cart?.discount_conditions?.isSubscriptionActivated,
        [data?.cart?.discount_conditions.isSubscriptionActivated],
    );


    const currentPrice = useMemo(
        () => (isSubscription ? getPriceForSubscription(menuDish?.data?.price) : menuDish?.data?.price),
        [isSubscription, menuDish.data.price],
    );

    return formatPrice(currentPrice);
};
